<template>
  <div id="student-interaction-page">
    <custom-text :msg="customText" :customValue="studentData" class="mt-3"></custom-text>
    <v-flex v-if="!isStudent && $vuetify.breakpoint.mdAndUp" class="text-xs-right pt-2">
      <v-btn color="primary" class="primary-text" @click="createInterventionForStudent">
        <v-icon left>mdi-account-multiple</v-icon>
        {{$t('interactions_create_intervention')}}
      </v-btn>
      <v-btn color="primary" class="primary-text" @click="createExemptionForStudent">
        <v-icon left>timelapse</v-icon>
        {{$t('interactions_create_exemption')}}
      </v-btn>
    </v-flex>
    <transition-group name="list" tag="div" class="pt-3">
      <student-profile-interaction
        v-for="interaction in interactions"
        :key="interaction.id" class="expansion-panel-custom"
        :interaction="interaction" :active="active"/>
    </transition-group>
    <div v-if="interventionsLoadedNoResults" class="info info-text info-message">
      {{$t('interventions_empty_list_student')}}
    </div>
    <fab-dial v-if="!isStudent && $vuetify.breakpoint.smAndDown" :color="$vuetify.theme.secondary" closed-icon="add"
              :buttons="buttons" :nudge-bottom="undoSnackbarState"/>
  </div>
</template>

<script>
  import StudentProfileInteraction from '../../intervention/studentProfileIntervention/StudentProfileInteraction'
  import { GET_STUDENT_INTERACTIONS } from '../../../store/action-types'
  import FabDial from '../../misc/fab/FabDial'
  import { IS_STUDENT } from '../../../store/getter-types'
  import { mapGetters, mapActions, mapState } from 'vuex'
  import Colors from '../../../mixins/Colors'
  import CreateInteraction from '../../../mixins/CreateInteraction'
  import Undo from '../../../mixins/Undo'
  import CustomText from '../../help/CustomText'
  import Roles from '../../../mixins/Roles'

  export default {
    components: {
      FabDial,
      StudentProfileInteraction,
      CustomText
    },
    name: 'student-interaction-page',
    props: ['interactions', 'interventionsLoading', 'student', 'studentId', 'active'],
    mixins: [Colors, CreateInteraction, Undo, Roles],
    data () {
      return {
        buttons: []
      }
    },
    methods: {
      ...mapActions({
        getInteractions: GET_STUDENT_INTERACTIONS
      }),
      loadData () {
        this.getInteractions(this.studentId)
      }
    },
    computed: {
      interventionsLoadedNoResults () {
        return (!this.interventionsLoading) && (this.interactions.length === 0)
      },
      ...mapGetters({
        isStudent: IS_STUDENT
      }),
      ...mapState({
        studentData: state => state.student
      }),
      customText () {
        let role = this.isAdmin ? 'admin' : (this.isStaff ? 'staff' : 'student')
        return 'custom-text.' + role + '.interactions'
      }
    },
    watch: {
      active (value) {
        if (value) {
          this.loadData()
        }
      }
    },
    mounted () {
      if (this.active) {
        this.loadData()
      }
      this.buttons = [
        {
          icon: 'mdi-account-multiple',
          text: this.$t('interactions_create_intervention'),
          color: this.materialColors.deepOrange.darken2,
          action: this.createInterventionForStudent
        },
        {
          icon: 'timelapse',
          text: this.$t('interactions_create_exemption'),
          color: this.materialColors.green.darken2,
          action: this.createExemptionForStudent
        }]
    }
  }
</script>

<style scoped>
  #student-interaction-page {
    min-height: 50vh;
  }

  .info-message {
    padding: 1em;
    text-align: center;
    width: 100%;
  }
  .expansion-panel-custom {
    border-top: 1px solid rgba(0,0,0,0.1)!important;
  }
  .expansion-panel-custom:hover{
    background: rgba(0,0,0,0.1)!important;
  }
</style>

<style>
  .expansion-panel__container:hover{
    background-color: rgba(0,0,0,0.1)!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/student/interaction/StudentInteractionPage.vue